import { all, put, takeLatest } from "redux-saga/effects";
import { apiCall } from "../../util/Api";
import { isValidElement, isValidString } from "../../util/ApiHelper";
import { showAlert } from "../../util/helper";
import { MY_EXIM_API_OFFER_PRODUCTS } from "../services/offerProductsNetwork";
import { MY_OFFER_PRODUCTS_TYPES } from "../types/myOfferProductsTypes";
import { push } from "connected-react-router";
import { getOfferProductsAction } from "../actions/myOfferProductsAction";
import { FETCH_START, FETCH_SUCCESS } from "../types/commonTypes";

function* makeCreateOfferProducts(action) {  
  try {
    yield put({ type: FETCH_START });
    let response;
    if (isValidString(action?.id)) {
      response = yield apiCall(
        MY_EXIM_API_OFFER_PRODUCTS.updateOfferProduct,
        action
      );
    } else {
      response = yield apiCall(
        MY_EXIM_API_OFFER_PRODUCTS.createOfferProduct,
        action
      );
    }
    if (isValidElement(response)) {
      yield put(push(`/offer-your-cargo`));
      yield put({
        type: MY_OFFER_PRODUCTS_TYPES.CREATE_OFFER_PRODUCT_SUCCESS,
        payload: response,
      });
    }
  } catch (e) {
    showAlert("error", "Something went wrong");
  }finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeOfferProductById(action) {
  try {
    yield put({ type: FETCH_START });
    const response = yield apiCall(
      MY_EXIM_API_OFFER_PRODUCTS.offerProductById,
      action
    );
    if (isValidElement(response?.data?.data)) {
      yield put({
        type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCT_BY_ID_SUCCESS,
        payload: response?.data?.data,
      });
    } else {
      yield put({
        type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCT_BY_ID_SUCCESS,
        payload: null,
      });
    }
  } catch (e) {
    showAlert("error", e.message);
  } finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeOfferProductsList(action) {
  try {
    yield put({ type: FETCH_START });
    const response = yield apiCall(
      MY_EXIM_API_OFFER_PRODUCTS.getOfferProductsList,
      action
    );

    if (response.data) {
      yield put({
        type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_FAILURE,
      error,
    });
    showAlert("error", "Failed to fetch offer products");
  }finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeOfferProductsExporterList(action) {
  try {
    yield put({ type: FETCH_START });
    const response = yield apiCall(
      MY_EXIM_API_OFFER_PRODUCTS.getOfferProductsListExporter,
      action
    );

    if (response.data) {
      yield put({
        type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_EXPORTER_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_EXPORTER_FAILURE,
      error: error.message,
    });
    showAlert("error", "Failed to fetch offer products");
  }finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

function* makeDeleteOfferProduct(action) {
  try {
    yield put({ type: FETCH_START });
    yield apiCall(MY_EXIM_API_OFFER_PRODUCTS.deleteOfferProduct, action);

    console.log('delete offer product 1');
    yield put(getOfferProductsAction(1, 10));
    console.log('delete offer product 2');
    yield put({
      type: MY_OFFER_PRODUCTS_TYPES.DELETE_MY_OFFER_PRODUCT_SUCCESS,
      product_id: action.product_id,
    });
  } catch (e) {
    showAlert(
      "error",
      e?.response?.data?.message || "Failed to delete Offer product"
    );
  }finally {
    yield put({ type: FETCH_SUCCESS });
  }
}

export default function* myProductSaga() {
  yield all([
    takeLatest(
      MY_OFFER_PRODUCTS_TYPES.CREATE_OFFER_PRODUCT,
      makeCreateOfferProducts
    ),
    takeLatest(
      MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST,
      makeOfferProductsList
    ),
    takeLatest(
      MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_EXPORTER,
      makeOfferProductsExporterList
    ),
    takeLatest(
      MY_OFFER_PRODUCTS_TYPES.DELETE_MY_OFFER_PRODUCT,
      makeDeleteOfferProduct
    ),
    takeLatest(
      MY_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCT_BY_ID,
      makeOfferProductById
    ),
  ]);
}
